import React from 'react';

import { EIntegration } from 'pages/partners/components/IntegrationsTab/constants';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { ConsumerSettings, IntegrationVendor } from 'apis/PartnerApi';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { useSuperState } from 'hooks';

type LTIApiIntegrationProps = {
    consumerSettings?: ConsumerSettings;
    copyClipboardWithMessage: (copyText: string) => void;
    generateLTIKeyAndSecret: (integrationType: EIntegration) => void
    integration: IntegrationVendor;

}

export const LTIApiIntegration = ({ consumerSettings, copyClipboardWithMessage, generateLTIKeyAndSecret, integration }: LTIApiIntegrationProps) => {

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        showCredentials: false
    });

    const dynamicRegistrationURL = consumerSettings?.Identifier && consumerSettings?.AdvantageToolBaseURL
        ? `${consumerSettings.AdvantageToolBaseURL}${consumerSettings.Identifier}`
        : '';

    const hasCredentials = integration.Key && integration.Key.length > 0 && integration.Secret && integration.Secret.length > 0;

    const handleRequestClick = async () => {

        if (!hasCredentials) {

            await generateLTIKeyAndSecret(EIntegration.GMetrix);

        }

        setState({ showCredentials: !state.showCredentials });

    };

    return (
        <>
            <h5 className="my-3 integrations__title">
                <FormattedMessage defaultMessage="GMetrix LTI Integration" id="gmetrix_lti_integration.ccfd177d" />
            </h5>

            {state.showCredentials && hasCredentials && (
                <div className="mb-4 border rounded bg-light">
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-white">
                        <div>
                            <img alt="" className="me-2" height="16" src="/Images/Icons/shape_square_go.png" width="16" />
                            <a href="http://gmetrix.net/documentation/Documents/GMetrixLTIIntegrationV3.pdf" rel="noopener noreferrer" target="_blank">
                                <FormattedMessage defaultMessage="Getting Started With LTI" id="getting_started_with_lti.a7b604ab" />
                            </a>
                        </div>
                        <button
                            aria-label={formatMessage({ id: 'close.99e01fb5', defaultMessage: 'Close' })}
                            className="btn-close"
                            onClick={() => setState({ showCredentials: false })}
                        />
                    </div>
                    <div className="p-3">
                        <p className="mb-3">
                            <FormattedMessage defaultMessage="Your LTI Tool Consumer Credentials have been created." id="your_lti_tool_consumer_credentials_have.66512cff" />
                        </p>

                        <h6 className="mb-3">
                            <FormattedMessage defaultMessage="LTI 1.1" id="lti_11.dac570eb" />
                        </h6>
                        <Row>
                            <Col className="mb-3 col-12 col-lg-6">
                                <Row>
                                    <Col className="col-8">
                                        <GMetrixInput
                                            readOnlyNoLock
                                            label={formatMessage({ id: 'consumer_key.0bfc65df', defaultMessage: 'Consumer Key' })}
                                            value={integration.Key}
                                        />
                                    </Col>
                                    <Col className="d-flex align-items-end col-4">
                                        <GMetrixButton onClick={() => integration.Key && copyClipboardWithMessage(integration.Key)} variant='primary'>
                                            <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                                        </GMetrixButton>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="mb-3 col-12 col-lg-6">
                                <Row>
                                    <Col className="col-8">
                                        <GMetrixInput
                                            readOnlyNoLock
                                            label={formatMessage({ id: 'secret.f941d41a', defaultMessage: 'Secret' })}
                                            value="NA"
                                        />
                                    </Col>
                                    <Col className="d-flex align-items-end col-4">
                                        <GMetrixButton onClick={() => integration.Secret && copyClipboardWithMessage(integration.Secret)} variant='primary'>
                                            <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                                        </GMetrixButton>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        {dynamicRegistrationURL && (
                            <>
                                <h6 className="mb-3 mt-4">
                                    <FormattedMessage defaultMessage="LTI Advantage" id="lti_advantage.054af74b" />
                                </h6>
                                <Row>
                                    <Col className="mb-3 col-12">
                                        <Row>
                                            <Col className="col-10">
                                                <GMetrixInput
                                                    readOnlyNoLock
                                                    label={formatMessage({ id: 'dynamic_registration_url.7a7f5fc6', defaultMessage: 'Dynamic Registration URL' })}
                                                    value={dynamicRegistrationURL}
                                                />
                                            </Col>
                                            <Col className="d-flex align-items-end col-2">
                                                <GMetrixButton onClick={() => copyClipboardWithMessage(dynamicRegistrationURL)} variant='primary'>
                                                    <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                                                </GMetrixButton>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </div>
                </div>
            )}

            {!state.showCredentials && (
                <GMetrixButton className="mb-3" onClick={handleRequestClick} variant="primary">
                    <FormattedMessage defaultMessage="Request LTI Key and Secret" id="request_lti_key_and_secret.42022008" />
                </GMetrixButton>
            )}

            <hr />
        </>
    );

};
